import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import Slide from '@mui/material/Slide'
import {TransitionProps} from '@mui/material/transitions'
import {styled} from '@mui/material'
import { useDispatch } from 'react-redux'
import { logout } from '../../../app/modules/auth/core/_requests'
// import { useAuth } from '../../../app/modules/auth'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />
})

const Title = styled('h4')(() => ({
  margin: 0,
  marginBottom: '8px',
  textTransform: 'capitalize',
}))

const DialogBox = styled('div')(() => ({
  width: 360,
  padding: '32px',
  textAlign: 'center',
  marginLeft: 'auto',
  marginRight: 'auto',
}))

const Controller = styled('div')(() => ({
  margin: '8px',
  paddingTop: '8px',
  display: 'flex',
  justifyContent: 'center',
}))

interface ConfirmationModal {
  open: string
  text: string
  onConfirmDialogClose: React.MouseEventHandler<HTMLButtonElement> | undefined
}

const ErrorDialog = ({open, text, onConfirmDialogClose}: ConfirmationModal) => {
  // const {logout} = useAuth()
  const dispatch = useDispatch()
  return (
    <div>
      <Dialog
        open={open ? true : false}
        TransitionComponent={Transition}
        keepMounted
        onClose={onConfirmDialogClose}
      >
        <DialogBox>
          <i className='text-danger fs-2tx bi bi-exclamation-circle'></i>
          <Title className='mt-5'>Error!</Title>
          <p>{text==="Unauthorized" ? "Your session has expired, please login again" : text }</p>
          <Controller>
            <span className='m-1'></span>
            {text === 'Unauthorized' ? (
              <button className='btn btn-primary btn-sm' onClick={()=>{logout(dispatch)}}>
                Ok
              </button>
            ) : (
              <button className='btn btn-primary btn-sm' onClick={onConfirmDialogClose}>
                Ok
              </button>
            )}
          </Controller>
        </DialogBox>
      </Dialog>
    </div>
  )
}

export default ErrorDialog
